export default __webpack_public_path__ + "static/graphql-cdafd64d6974c9123c4a9d2bdb81ed47.png";